export const flagshipHotelsTestIds = {
  section_title: 'flagship_hotels_section_title',
};

export const cardTestIds = {
  with_campaign_cheapest_price: 'flagship_with_campaign_cheapest_price',
  no_campaign_cheapest_price: 'flagship_no_campaign_cheapest_price',
  with_campaign_discount_amount: 'flagship_with_campaign_discount_amount',
  campaign_img: 'flagship_campaign_img',
};
